import { ActionReducerMap } from '@ngrx/store';
import { StorySeoState } from './state';
import { storyblokSeoReducer } from './storyblok-seo';

export const reducers: ActionReducerMap<StorySeoState> = {
  storyblokSeo: storyblokSeoReducer,
};
